"use client";

import React, { Fragment } from 'react';
import { useRouter } from 'next/navigation'
import { useGlobalContext } from "../component/context/provider";
import Link from 'next/link';

import LazySection from "../component/Responsive/home/LazySection";

import MainBanner from '../component/Responsive/home/banner/MainBanner';
import BookSlideSet from '../component/Responsive/home/book/BookSlideSet';
import BookSlideSetB from '../component/Responsive/home/book/BookSlideSetB';
import BookSlideSetC from '../component/Responsive/home/book/BookSlideSetC';
import BookSlideSetD from '../component/Responsive/home/book/BookSlideSetD';
import BookSlideSetE from '../component/Responsive/home/book/BookSlideSetE';
import CategoryRow from '../component/Responsive/home/category/CategoryRow';

export default function Homepage({ data }) {
    // console.log(data);

    const router = useRouter()
    const { screen } = useGlobalContext()

    // แบนเนอร์หลักใช้ column 45 ส่วนคอลัมน์อื่นคงลำดับจาก API
    const AllColumns = data?.Column_data?.filter(Boolean) ?? []
    const BannerData = AllColumns.find((column) => Number(column?.[0]?.column_data?.id) === 45)
    const ColumnData = AllColumns.filter((column) => column !== BannerData)

    // แทรกหมวดหมู่เข้าไปในลำดับที่ 2 ของ ColumnData
    if (data?.cate_data?.length > 0) {
        ColumnData.splice(0, 0, { is_category: true, cate_data: data.cate_data })
    }

    // sort column_book ตาม sort_order (ใหม่) หรือ order_id[0].order (เก่า สำหรับ banner/ads)
    const sortedColumn = (item) => {
        if (!item) return item
        return item.map((col) => {
            if (!col?.column_book) return col
            const sorted = [...col.column_book].sort((a, b) => {
                // ใช้ sort_order ถ้ามี (data จาก BookSeriesColumnOrder ใหม่)
                if (a.sort_order != null && b.sort_order != null) {
                    return a.sort_order - b.sort_order
                }
                // fallback สำหรับ data เก่า (banner/ads ที่ยังใช้ order_id array)
                const orderA = Array.isArray(a.order_id) ? a.order_id[0]?.order ?? 0 : 0
                const orderB = Array.isArray(b.order_id) ? b.order_id[0]?.order ?? 0 : 0
                return orderA - orderB
            })
            return { ...col, column_book: sorted }
        })
    }

    // console.log(data);


    return (
        <div className="w-[100%] ">
            {(data && BannerData) &&
                <MainBanner data={BannerData} />
            }
            <div className="px-[10px] md:px-[10px] xl:px-[10%] text-primary">
                {ColumnData?.length > 0 && ColumnData?.map((item, index) => {
                    if (item?.is_category) {
                        return <CategoryRow data={item.cate_data} key={`cate-${index}`} />
                    }

                    const sorted = sortedColumn(item)
                    if (!sorted?.[0]?.column_book || sorted[0].column_book.length === 0) {
                        return null
                    }

                    const autoKey = sorted[0]?.column_data?.auto_key
                    const bannerSize = sorted[0]?.column_data?.banner_size

                    let columnContent = null
                    if (autoKey === 'preorder') {
                        columnContent = <BookSlideSetE data={sorted} />
                    } else if (bannerSize === 'A') {
                        columnContent = <BookSlideSet data={sorted} />
                    } else if (bannerSize === 'B') {
                        columnContent = <BookSlideSetB data={sorted} />
                    } else if (bannerSize === 'C') {
                        columnContent = <BookSlideSetC data={sorted} />
                    } else if (bannerSize === 'D') {
                        columnContent = <BookSlideSetD data={sorted} />
                    } else {
                        return null
                    }

                    // 2-3 คอลัมน์แรกโหลดทันที ส่วนคอลัมน์ด้านล่างห่อด้วย LazySection
                    if (index < 3) {
                        return <Fragment key={index}>{columnContent}</Fragment>
                    }

                    return (
                        <LazySection key={`lazy-col-${index}`} minHeight={360}>
                            {columnContent}
                        </LazySection>
                    )
                })}
            </div>
            {screen !== 'mobile' ? (
                <div className="h-[127px] bg-[#5C0036] items-center flex justify-between px-[10px] md:px-[10px] xl:px-[10%] mt-[1.5em]">
                    <div className="flex items-center gap-[1.5em]">
                        <img
                            className="h-[113px]"
                            src="https://eve-image.eveebook.com/image.eveebook/mascot/happy.png"
                            alt="happy_rabbit"
                            loading="lazy"
                            decoding="async"
                            width={113}
                            height={113}
                        />
                        <div className="flex flex-col text-white">
                            <div className="md:text-[28px] xl:text-[32px] font-medium">คุณเองก็เป็นได้แล้วนะ คนขายน่ะ</div>
                            <div className="md:text-[16px] xl:text-[18px] font-medium">ลงขายอีบุ๊คของคุณได้แล้วสมัครเลยวันนี้</div>
                        </div>
                    </div>
                    <Link href="https://writer.eveebook.com" target="_blank" rel="noopener noreferrer">
                        <button className="btn-light h-[48px] w-[216px] rounded-[24px] text-white">เริ่มขาย eBook ของคุณ</button>
                    </Link>
                </div>
            ) : (<div className="py-[1em]"></div>)}
        </div>
    )
}

